/**
 * Retry policy for queries that can legitimately be refused.
 *
 * React Query's default is three retries with backoff, which is right for a
 * flaky network and wrong for a 403: the answer will not change, and the user
 * spends the whole backoff staring at a loading state before finally being told
 * they can't do the thing. Client errors fail fast; everything else keeps the
 * default.
 */
export function retryUnlessClientError(failureCount: number, error: unknown): boolean {
  const code = (error as { code?: number })?.code;
  if (typeof code === 'number' && code >= 400 && code < 500) return false;
  return failureCount < 3;
}

/** Whether an error is the server refusing, rather than failing. */
export function isPermissionError(error: unknown): boolean {
  const code = (error as { code?: number })?.code;
  return code === 401 || code === 403;
}
